import React, { useEffect } from 'react';

import { ReactComponent as SuccessSvg } from '@assets/icons/success.svg';
import { ReactComponent as UndoSvg } from '@assets/icons/undo.svg';
import { ReactComponent as CrossSvg } from '@assets/icons/cross.svg';

function ActionToast({ title, description, onUndo, closeToast }) {
  useEffect(() => {
    if (!onUndo) return;
    const elems = document.querySelectorAll('.Toastify__toast');

    const row = document.createElement('div');
    elems.forEach((el) => {
      const node = el.querySelector('.Toastify__back_row');
      if (!node) {
        row.classList.add('Toastify__back_row');
        el.appendChild(row);
      }
    });
  });
  return (
    <div className="toast_container">
      <div>
        <div className="toast_container__icon">
          <SuccessSvg />
        </div>
        <div className="toast_container__body">
          <div className="title">{title}</div>
          {description && <div className="description">{description}</div>}
        </div>
      </div>

      <div className="toast_container__action">
        {onUndo && (
          <span
            className="undo"
            onClick={() => {
              onUndo();
              closeToast();
            }}
          >
            <UndoSvg /> Undo
          </span>
        )}
        <span
          className="close"
          onClick={() => {
            closeToast();
          }}
        >
          <CrossSvg style={onUndo ? {} : { marginLeft: 8 }} />
        </span>
      </div>
    </div>
  );
}

export default ActionToast;
